<template>
  <a-modal
    :visible="visible"
    :title="title"
    :body-style="{'padding': '0 0 24px 0'}"
    :footer="null"
    :width="640"
    :mask-closable="false"
    :destroy-on-close="true"
    @cancel="close"
  >
    <p class="model_tip">
      <span v-text="tip" />
      <a
        v-if="help"
        :href="url"
        target="_blank"
        class="tip_help"
      >{{ $t('message["86"]') }}</a>
    </p>
    <!-- 代码部分 -->
    <div class="content_body">
      <slot name="content" />
    </div>
  </a-modal>
</template>

<script type="text/ecmascript-6">
import i18n from '@/lib/language'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: i18n.t('message["323"]')
    },
    tip: {
      type: String,
      default: 'tip'
    },
    help: {
      type: Boolean,
      default: true
    },
    url: {
      type: String,
      default: '#'
    }
  },
  data () {
    return {
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.model_tip {
  width: 100%;
  background: #e8f4ff;
  padding: 8px 24px;
  .tip_help {
    color: #4ca0f2;
    margin-left: 16px;
  }
}
.content_body {
  margin: 24px;
}
</style>
